import React, { createContext, useState } from "react";
import { Navigate } from "react-router-dom";
import { ShowToast, Severty } from "../helper/toast";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // ✅ Load immediately from localStorage
  const storedUser = JSON.parse(localStorage.getItem("userProfile"));
  const storedToken = localStorage.getItem("token");

  const [isLoggedIn, setIsLoggedIn] = useState(!!storedToken);
  const [session, setSession] = useState({ token: storedToken });
  const [userProfile, setUserProfile] = useState(storedUser || null);
  const [userPermission, setUserPermission] = useState(
    storedUser?.roleId?.permission || []
  );

  const login = () => {
    setIsLoggedIn(true);
    return <Navigate to="/dashboard" />;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userProfile");
    ShowToast("Logout Successfully", Severty.SUCCESS);
    window.location.assign("/login");
    return <Navigate to="/login" />;
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        session,
        setSession,
        userProfile,
        setUserProfile,
        userPermission,
        setUserPermission,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
